let BASE_URL = "";

if (process.env.NODE_ENV === "development") {
  BASE_URL = "http://localhost:3001";
} else if (process.env.NODE_ENV === "production") {
  BASE_URL = "https://painel.relinqscore.com.br";
}

BASE_URL += "/api-rscore";

const LOGIN = {
  POST_LOGIN: BASE_URL + "/acessar",
  CREATE_NEW_USER: BASE_URL + "/customer/new",
  FORGOT_PASSWORD: BASE_URL + "/forgot-password",
};

const API = {
  GET_TOKEN: "/get-api-rest-token",
};

const AUDIT = {
  CREATE: "/audit-history", // POST
  CREATE_IF_CHANGED: "/audit-history/diff", // POST
  LIST_BY_ENTITY: (entityName, entityId) =>
    `/audit-history/entity/${entityName}/${entityId}`, // GET
  LATEST_FOR_ENTITY: (entityName, entityId) =>
    `/audit-history/entity/${entityName}/${entityId}/latest`, // GET
  LIST_BY_COMPANY: (companyId) => `/audit-history/company/${companyId}`, // GET
};

const CATEGORIES = {
  GET_ALL: "/categories",
};

const COMPANY = {
  GET_PERMISSION_QUERIES: "/company/permission/queries",
  GET_DOCS: "/company/docs",
  ACCEPT_TERMS: "/accept-terms",
  GET_COMPANY_NAME_BY_UUID: "/company/get-company-name-by-uuid",
  COMPANY: "/company",
};

const USERS = {
  GET_USERS: "/users",
  GET_USER: "/user",
  GET_USER_CURRENT: "/user-current",
  GET_USER_QUERY_PERMISSIONS: "/user-query/permission",
  GET_USER_BY_EMAIL: "/user/email",
};

const ADMIN = {
  GET_ACCESS_TODAY: "/admin/accesses/today",
  GET_ANNOTATION: "/admin/annotation",
  GET_ANNOTATIONS: "/admin/annotations",
  GET_CUSTOMERS: "/admin/customers",
  GET_MY_CUSTOMERS: "/my-customers",
  GET_REPRESENTATIVES: "/admin/representatives",
  GET_REPRESENTATIVES_METRICS: "/admin/representatives-metrics",
  GET_COMPANY_QUERIES: "/admin/company/queries",
  GET_QUERIES: "/admin/queries",
  GET_QUERIES_LIST: "/admin/queries-list",
  GET_USERS: "/admin/users",
  GET_PROVIDER: "/admin/provider",
  GET_PROVIDERS: "/admin/providers",
  GET_PROVIDERS_ALL: "/admin/providers-all",
  NEW_CUSTOMER: "/admin/customer/new",
  NEW_REPRESENTATIVE: "/admin/representative/new",
  GET_COMPANY_BY_INFO: "/admin/company/info",
  GET_COMPANY: "/admin/company",
  GET_COMPANY_QUERIES_HISTORY: "/admin/queries/company",
  GET_COMPANY_QUERIES_HISTORY_SIMPLIFIED: "/admin/queries/company/simplified",
  GET_COMPANIES_BY_TABLE: "/admin/companies-by-table",
  GET_PAYMENTS: "/admin/payments",
  GET_QUERY: "/admin/query",
  GET_TABLE_QUERIES: "/admin/table/queries",
  GET_TABLES: "/admin/tables",
  GET_TABLE: "/admin/table",
  GET_SURVEY_REPORT: "/admin/survey/company",
  GET_CUSTOMIZED_QUERY: "/admin/customized-query",
  GET_HISTORY_INVOICES: "/admin/invoices/history",
  GET_TICKETS: "/admin/tickets",
  GET_QUERY_DETAILS: "/admin/query/details",
  GET_QUERY_RESPONSE: "/admin/query/response",
  GET_PROVIDER_USAGE: "/admin/provider/usage",
  UPDATE_PAYMENT: "/admin/payment/update",
  DELETE_PAYMENT: "/admin/payment/delete",
  GET_OVERVIEW: "/admin/overview",
  GET_OVERVIEW_LIST: "/admin/overview-list",
  GET_FINANCIAL_REPORT: "/admin/financial-report",
  GET_QUERY_PROVIDER_USAGE: "/admin/query-provider-usage-report",
  GET_FAILED_MODULAR_QUERY: "/admin/query-provider-failed-queries",
  RUN_CLOSING: "/admin/payment/manual",
  UPDATE_QUERY_PRICE: "/admin/query/price",
  UPDATE_CV_PRICE: "/admin/cv/price",
  UPDATE_REDUDANCY: "/admin/redudancy",
  GET_QUERY_CUSTOMIZED: "/admin/query-customized",
  EXPORT_FINANCIAL_REPORT: "/admin/financial-report/export/xlsx",
  EXPORT_QUERIES_HISTORY_REPORT: "/admin/queries-history/export/xlsx",
  EXPORT_QUERIES_HISTORY_SIMPLIFIED_REPORT:
    "/admin/queries-history-simplified/export/xlsx",
  GET_DAILY_INSIGHTS: "/admin/daily-insights", // agregador (todos os quadrantes)
  GET_DAILY_INSIGHTS_BY_QTY: "/admin/daily-insights/by-qty", // lista completa por quantidade
  GET_DAILY_INSIGHTS_BY_VALUE: "/admin/daily-insights/by-value", // lista completa por valor
  GET_DAILY_INSIGHTS_TOTAL: "/admin/daily-insights/total", // total de consultas + receita
  GET_DAILY_INSIGHTS_NEW_ACTIVES: "/admin/daily-insights/new-actives", // novos clientes ativos hoje
  GET_DAILY_INSIGHTS_TOP_CUSTOMERS: "/admin/daily-insights/top-clients",
  GET_DAILY_INSIGHTS_PRODUCTS: "/admin/daily-insights/products", // consultas por produto (RAW)
  GET_DAILY_INSIGHTS_PRODUCTS_PIE: "/admin/daily-insights/products/pie",
  GET_TOKEN: "/admin/get-token",
  GET_USER_QUERY_BY_PROTOCOL: "/user-query-protocol",
  GET_COMPANY_PRICES: "/admin/company-prices",
  COMPANY_FILES_BASE: "/admin/companies", // raiz
  COMPANY_FILES: "/admin/companies/:companyId/files",
  GET_ENGINE_CREDIT: "/credit-engine/config",
  SAVE_ENGINE_CREDIT: "/admin/credit-engine/config",
  GET_CREDIT_ENGINE_PRESETS: "/admin/credit-engine/presets",
  CREATE_CREDIT_ENGINE_PRESET: "/admin/credit-engine/presets",
  UPDATE_CREDIT_ENGINE_PRESET: (presetId) =>
    `/admin/credit-engine/presets/${presetId}`,
  DELETE_CREDIT_ENGINE_PRESET: (presetId) =>
    `/admin/credit-engine/presets/${presetId}`,
};

const BANNERS = {
  LIST: "/banners",
};

const BANNERS_ADMIN = {
  LIST: "/admin/banners",
  CREATE: "/admin/banners",
  GET: (id) => `/admin/banners/${id}`,
  UPDATE: (id) => `/admin/banners/${id}`,
  DELETE: (id) => `/admin/banners/${id}`,
};

const SELLER = {
  GET_COMPANY_BY_INFO: "/seller/company/info",
  GET_COMPANY_QUERIES: "/seller/company/queries",
};

const CHARGES = {
  SEND: "/charge/send",
  GET_ALL: "/charges",
  GET: "/charge",
  GET_TYPES: "/charges/types",
};

const QUERIES = {
  GET_DEFINE_RISCO: "/query/positivo-plus-cnpj",
  GET_DEFINE_LIMITE: "/query/define-limite",
  GET_DEFINE_LIMITE_POSITIVO: "/query/define-limite-positivo",
  GET_ACERTA_ESSENCIAL: "/query/positivo-plus-cpf",
  GET_ACERTA_COMPLETO: "/query/acerta-completo",
  GET_AVALIE: "/query/avalie",
  GET_COMPLETA_PLUS: "/query/completa-plus-cnpj",
  GET_COMPLETA_PLUS_CPF: "/query/completa-plus-cpf",
  GET_SERASA_BASICO: "/query/serasa-basico",
  GET_SCR_BACEN_SCORE: "/query/scr-bacen-score",
  GET_CADASTRAL_PF: "/query/cadastral-pf",
  GET_CADIN: "/query/cadin",
  GET_RESTRITIVA_PF: "/query/restritiva-pf",
  GET_CADASTRAL_PJ: "/query/cadastral-pj",
  GET_RESTRITIVA_PJ: "/query/restritiva-pj",
  GET_PROTESTO_NACIONAL: "/query/protesto-nacional",
  GET_REGULARIZE: "/query/regularize",
  GET_LOCALIZA_TELEFONE: "/query/localiza-telefone",
  GET_LOCALIZA_CPF: "/query/localiza-cpf",
  GET_LOCALIZA_CNPJ: "/query/localiza-cnpj",
  GET_CREDITO_PREMIUM_CPF: "/query/credito-premium-cpf",
  GET_CREDITO_PREMIUM_CNPJ: "/query/credito-premium-cnpj",
  GET_SERASA_PREMIUM_CPF: "/query/serasa-premium-cpf",
  GET_SERASA_PREMIUM_CNPJ: "/query/serasa-premium-cnpj",
  GET_INFOCRED_CPF: "/query/infocred-cpf",
  GET_INFOCRED_CNPJ: "/query/infocred-cnpj",
  GET_ACESSO_NET_CPF: "/query/acesso-net-cpf",
  GET_CNDT: "/query/cndt",
  GET_CREDITO_COMPLETO_QUOD: "/query/credito-completo-quod-pf",
  GET_CREDITO_COMPLETO_QUOD_PJ: "/query/credito-completo-quod-pj",
  GET_ACESSO_PRIME_CPF: "/query/acesso-prime-cpf",
  GET_ACESSO_PRIME_CNPJ: "/query/acesso-prime-cnpj",
  GET_RELATORIO_COMPLETO_CPF: "/query/relatorio-completo-cpf",
  GET_RELATORIO_COMPLETO_CNPJ: "/query/relatorio-completo-cnpj",
  GET_LOCALIZA_CNPJ: "/query/localiza-cnpj",
  GET_LAST_QUERIES: "/query/last",
  GET_LAST_7_DAYS_COUNT_QUERIES: "/query/total/last/7",
  GET_QUERIES_TOTAL: "/query/total",
  GET_QUERIES_LIST: "/queries",
  UPLOAD_PDF: "/query/upload/pdf",
  DOWNLOAD_PDF: "/query/download/pdf",
  GENERATE_PDF: "/generate/pdf",
  GET_DASHBOARD_INFOS: "/query/dashboard",
  GET_DASHBOARD_INFOS_REPRESENTATIVE: "/query/dashboard/representative",
  GET_DASHBOARD_INFOS_POWER_USER: "/query/dashboard/power-user",
  GET_V1_QUERY: "/v1",
  GET_V2_QUERY: "/v2",
  GET_QUERY: "/query",
  GET_IMG_CSV: "/proxy-laudo-csv",
  GET_USER_QUERY: "/query/user-query",
  ANALISAR_CREDITO: "/analisar-credito",
  REVIEW_QUERY: "/review-query",
  LOCALIZE: "/localize",
  LOCALIZE_PJ: "/localize-pj",
};

const QUERIES_VEICULAR = {
  GET_COMPLETA_VEICULAR: "/query/completa-veicular",
  GET_LEILAO_POSITIVO: "/query/leilao-positivo",
  GET_VEICULAR: "/query/veicular",
  GET_PRECIFICADOR: "/query/veicular/precificador",
  GET_BIN_NACIONAL: "/query/veicular/bin-nacional",
};

const AUDITS = {
  GET_AUDITS: "/audits",
};

const AVATAR = {
  UPLOAD: "/avatar/upload",
};

const PAYMENTS = {
  CREATE: "/payment/create",
  CREATE_PAYMENT_ADMIN: "/admin/payment/create",
  GET_ALL: "/invoices",
  ADD_CREDIT: "/payment/confirm",
  ADD_CREDIT_MANUALLY: "/payment/manually",
  OPEN_PAYMENTS: "/invoices/open",
};

const REPORTS = {
  GET_COMPANY_QUERIES_HISTORY: "/report/queries/company",
  GET_COMPANY_QUERIES_HISTORY_SIMPLIFIED: "/report/queries/company/simplified",
};

const SURVEYS = {
  GET_SURVEY: "/survey",
  GET_ALL_SURVEY: "/surveys",
  GET_TAGS: "/survey/tags",
  GET_SURVEY_VEHICLE: "/survey/vehicle",
  GET_SURVEY_CHECKLIST: "/survey/checklist",
  GET_CHECKLIST: "/survey/questions",
  UPLOAD_IMAGE: "/survey/image/upload",
  GET_SURVEY_IMAGES: "/survey/images",
  GET_CONFIG: "/survey/configs",
  FINISH: "/survey/finish",
  GET_REPORT: "/survey/report",
  DELETE_IMAGE_SURVEY: "/survey/image/upload",
};

const CVS = {
  GET_ALL: "/cvs",
  GET_CV: "/cv",
  EXPORT_CVS: "/cv/export",
  GET_REPORT: "/cv/report",
  UPLOAD_ATPV: "/cv/read-atpv",
  UPDATE: "/cv/update",
  CONSULT_RECEIPT: "/cv/assinatura-eletronica",
};

const TICKETS = {
  GET_ALL: "/tickets",
  CREATE: "/ticket",
};

const SYSTEM_VARIABLES = {
  GET_ALL: "/admin/system-variables",
  GET_BY_KEY: "/admin/system-variables", // uso: + "/:key"
  UPDATE: "/admin/system-variables/update",
  DELETE: "/admin/system-variables", // uso: + "/:key"
  RELOAD: "/admin/system-variables/reload",
};

const TAGS = {
  GET_ALL: "/admin/tags",
  GET_ALL_SIMPLE: "/admin/tags/all",
  GET: "/admin/tags",
  CREATE: "/admin/tags",
  UPDATE: "/admin/tags", // + "/:id"
  DELETE: "/admin/tags", // + "/:id"
  GET_BY_QUERY: "/queries", // GET    /queries/:queryId/tags
  SET_FOR_QUERY: "/queries", // PUT    /queries/:queryId/tags   (substitui todas as tags)
  ADD_TO_QUERY: "/queries", // POST   /queries/:queryId/tags   (adiciona tags)
  REMOVE_FROM_QUERY: "/queries", // DELETE /queries/:queryId/tags/:tagId
};

const NEGATIVE = {
  // CREATE
  CREATE: "/negative", // POST
  CREATE_CUSTOMER_NEGATIVE: "/negative-create-customer",

  // SEND TO EXTERNAL
  SEND: (id) => `/negative/${id}/send`, // POST

  // READ
  LIST: "/negative", // GET  (aceita ?companyId=... quando não usar a rota abaixo)
  LIST_BY_COMPANY: (companyId) => `/negative/company/${companyId}`, // GET
  GET: (id) => `/negative/${id}`, // GET

  // UPDATE
  UPDATE: (id) => `/negative/${id}`, // PATCH (payload parcial)

  // STATUS / BAIXA
  CHANGE_STATUS: (id) => `/negative/${id}/status`, // PATCH { status }
  BAIXA: (id) => `/negative/${id}/baixa`, // POST { motivoBaixa?, protocoloExterno? }

  // DELETE
  DELETE: (id) => `/negative/${id}`, // DELETE
  SEARCH_CUSTOMER: "/negative/search-customer",
  SEARCH_STATUS: "/negative/search-negative",
};

export {
  API,
  AUDIT,
  LOGIN,
  CATEGORIES,
  COMPANY,
  USERS,
  ADMIN,
  BANNERS,
  BANNERS_ADMIN,
  SELLER,
  CHARGES,
  QUERIES,
  QUERIES_VEICULAR,
  AUDITS,
  AVATAR,
  PAYMENTS,
  REPORTS,
  SURVEYS,
  CVS,
  TICKETS,
  SYSTEM_VARIABLES,
  TAGS,
  NEGATIVE,
  BASE_URL,
};
